import React from 'react';
import ReactTooltip from 'react-tooltip';

import './Tooltip.scss';

type TooltipProps = {
  // The ID which to be used for the tooltip. This identifies it amongst the others on the page.
  target: string;
}

export class Tooltip extends React.Component<TooltipProps> {

  render() {
    return <ReactTooltip id={this.props.target} aria-haspopup='true' type="light" border={true} borderColor="gray"
                         className="Tooltip">
      {this.props.children}
    </ReactTooltip>
  }
}
